import { TypographyMuted } from '@talentmesh/ui/components/typography';
import { useAssessmentsOverviewContext } from '../Contexts/AssessmentsOverviewContext';
import EmptyAssessmentsOverview from './EmptyAssessmentOverview/EmptyAssessmentsOverview';
import UIStrings from '@/Utils/UIStrings';

const EmptyRecruitmentList = () => {
    const { search } = useAssessmentsOverviewContext();

    return (
        <>
            {search && (
                <div className="bg-card flex h-60 items-center justify-center rounded-xl">
                    <TypographyMuted>{UIStrings.NoExactMatchesFound}</TypographyMuted>
                </div>
            )}
            {!search && <EmptyAssessmentsOverview />}
        </>
    );
};

export default EmptyRecruitmentList;
